import type { CreatureEncounterResourceDefaultsInput, CreatureEncounterResourceDefaultsResult } from '../types';

/** Apply the encounter-only luck and mana defaults used by the creature finalizer. */
export function applyCreatureEncounterResourceDefaults(
    input: CreatureEncounterResourceDefaultsInput,
): CreatureEncounterResourceDefaultsResult {
    let { luck, mana, manaPercent } = input;
    if (input.hasEncounterCreatureId) {
        luck ??= 0;
        if (!input.manaLayerPresent && mana === null) {
            mana = input.spirit;
            manaPercent = 100;
        }
    }
    return { luck, mana, manaPercent };
}
